import React from 'react'

import { Typography } from 'antd'
import classNames from 'classnames'

const { Text } = Typography

interface Props {
  paddingLeft?: boolean
  noPadding?: boolean
  children?: React.ReactNode
}

const FormItemError = (props: Props) => (
  <Text
    type="danger"
    className={classNames(
      'formik-field__error block',
      {
        'pl-24': props.paddingLeft,
      },
      {
        'pl-12': !props.paddingLeft,
      },
      {
        'p-0': props.noPadding,
      },
    )}
  >
    {props.children}
  </Text>
)
export { FormItemError as FormError }
export default FormItemError
